export const getCmlCloudProductIds = (): string[] =>
  globalThis.env?.CML_CLOUD_PRODUCT_IDS || [];

export const isCmlCloudProductId = (
  productGuid?: string | number | null
): boolean => {
  const ProductGuid = productGuid?.toString();
  return !!ProductGuid && getCmlCloudProductIds().includes(ProductGuid);
};
